import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6eb08035")

_pushScopeId("data-v-6eb08035")
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "content flex justify-between" }
const _hoisted_3 = { class: "nav-title" }
const _hoisted_4 = { class: "navs flex" }
const _hoisted_5 = { class: "controllers flex" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "message" }, null, -1)
const _hoisted_7 = { class: "user-info flex" }
const _hoisted_8 = { class: "herd-img" }
const _hoisted_9 = { class: "align-center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "个人中心", -1)
const _hoisted_11 = { class: "align-center" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "退出账号", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DownOutlined = _resolveComponent("DownOutlined")
  const _component_UserOutlined = _resolveComponent("UserOutlined")
  const _component_a_menu_item = _resolveComponent("a-menu-item")
  const _component_ExportOutlined = _resolveComponent("ExportOutlined")
  const _component_a_menu = _resolveComponent("a-menu")
  const _component_a_dropdown = _resolveComponent("a-dropdown")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", {
          class: "pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.routeTo(_ctx.headers[0], 0)))
        }, _toDisplayString(_ctx.projectName || '应急管理系列实训软件'), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headers, (n, i) => {
          return (_openBlock(), _createBlock("div", {
            class: ["nav pointer", {'nav-actived': n.isActived, 'nav-disabled': !n.pathName}],
            onClick: ($event: any) => (_ctx.routeTo(n, i))
          }, _toDisplayString(n.name), 11, ["onClick"]))
        }), 256))
      ]),
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("img", { src: _ctx.headImagePath }, null, 8, ["src"])
          ]),
          _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
            overlay: _withId(() => [
              _createVNode(_component_a_menu, null, {
                default: _withId(() => [
                  _createVNode(_component_a_menu_item, {
                    key: "0",
                    onClick: _ctx.handleUserInfo
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_9, [
                        _createVNode(_component_UserOutlined),
                        _hoisted_10
                      ])
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_a_menu_item, {
                    key: "1",
                    onClick: _ctx.handleLogoutClick
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_11, [
                        _createVNode(_component_ExportOutlined),
                        _hoisted_12
                      ])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            default: _withId(() => [
              _createVNode("span", {
                class: "pointer",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _createTextVNode(_toDisplayString(_ctx.userName), 1),
                _createVNode(_component_DownOutlined)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
})